var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var simpleOptions = new Array(6).fill(null).map(function (_, i) {
    return i === 4
        ? { divider: true }
        : {
            id: "".concat(i),
            value: "Input Text ".concat(i + 1),
            isSelectable: i < 3,
        };
});
export var optionsWithSubtitle = simpleOptions.map(function (option, i) { return (__assign(__assign({}, option), { subtitle: i === 0
        ? "The longest subtitle has 2 lines. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
        : "Subtitle Text ".concat(i) })); });
export var optionsWithUnavailableItems = [
    {
        id: '0',
        value: 'Site Pages (selectable)',
        isSelectable: true,
    },
    {
        id: '1',
        value: 'Home (not selectable)',
        isSelectable: false,
    },
    {
        id: '2',
        value: 'Shop (unavailable)',
        unavailable: true,
    },
];
export var optionsWithIcon = "[{\n    id: '1',\n    value: 'Share 01',\n    isSelectable: true,\n    icon: <Icons.Share />\n}, {\n    id: '2',\n    value: 'Share 02',\n    isSelectable: true,\n    icon: <Icons.Share />\n}]";
export var optionsWithIconAndSubtitles = "[{\n    id: '1',\n    value: 'Share 01',\n    subtitle: 'Subtitle Share 01',\n    isSelectable: true,\n    icon: <Icons.Share />\n}, {\n    id: '2',\n    value: 'Share 02',\n    subtitle: 'Subtitle Share 02',\n    isSelectable: true,\n    icon: <Icons.Share />\n}]";
export var optionsWithSuffix = "[{\n    id: '1',\n    value: 'Share 01',\n    subtitle: 'Subtitle Share 01',\n    isSelectable: true,\n    suffix: <Counter />\n}, {\n    id: '2',\n    value: 'Share 02',\n    subtitle: 'Subtitle Share 02',\n    isSelectable: true,\n    suffix: <Counter />\n}]";
export var optionsWithSections = [
    {
        id: '0',
        value: 'Site Pages',
        isSectionTitle: true,
        isSelectable: false,
    },
    {
        id: '1',
        value: 'Home',
        isSelectable: true,
    },
    {
        id: '2',
        value: 'Shop',
        isSelectable: true,
    },
    {
        id: '3',
        value: 'About',
        isSelectable: true,
    },
    {
        id: '4',
        value: 'Blog Posts',
        isSectionTitle: true,
        isSelectable: false,
    },
    {
        id: '5',
        value: '11 Proven Ways to Monetize a Website',
        isSelectable: true,
    },
];
export var numberOptions = new Array(6).fill(null).map(function (_, i) { return ({
    id: "".concat(i),
    value: "0".concat(i + 1),
    isSelectable: true,
}); });
export var modifyOptions = function (options) {
    return options.map(function (option) {
        return option.unavailable
            ? __assign(__assign({}, option), { 
                // Should internally add the `isSelectable` property to the item (needed by the wix-ui-core dropdown in order to trigger the onClick event)
                isSelectable: option.isSelectable === undefined ? true : option.isSelectable }) : option;
    });
};
export var optionsWithTextWrap = [
    {
        id: '0',
        value: 'Input Text 1Input Text 1Input Text 1Input Text 1Input Text 1Input Text 1Input Text 1Input Text 1Input Text 1Input Text 1Input Text 1Input Text 1',
        isSelectable: true,
        textOverflow: 'wrap',
    },
    { id: '1', value: 'Input Text 2', isSelectable: true, textOverflow: 'wrap' },
];
export var optionsWithTextEllipsis = [
    {
        id: '0',
        value: 'Input Text 1Input Text 1Input Text 1Input Text 1Input Text 1Input Text 1Input Text 1Input Text 1Input Text 1Input Text 1Input Text 1Input Text 1',
        isSelectable: true,
        textOverflow: 'ellipsis',
    },
    {
        id: '1',
        value: 'Input Text 2',
        isSelectable: true,
        textOverflow: 'ellipsis',
    },
];
//# sourceMappingURL=helpers.js.map